import { SxProps, Theme } from '@mui/material';

const detailContainer: SxProps<Theme> = (theme) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(3.75, 0, 2.5),
});

const chartsContainer: SxProps<Theme> = () => ({
  '@media print': {
    canvas: {
      minHeight: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      height: 'auto!important',
      width: 'auto!important',
    },
  },
});

const styles = {
  detailContainer,
  chartsContainer,
};

export default styles;
